export default "__VITE_ASSET__51d2a041__"